import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-after-audit',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './after-audit.component.html',
  styleUrl: './after-audit.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AfterAuditComponent implements OnInit {
  ngOnInit(): void {
    // Component chỉ hiển thị return component, không cần tab navigation
  }
} 